import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=a4b46c7e&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"
import style0 from "./Card.vue?vue&type=style&index=0&id=a4b46c7e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b46c7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4b46c7e')) {
      api.createRecord('a4b46c7e', component.options)
    } else {
      api.reload('a4b46c7e', component.options)
    }
    module.hot.accept("./Card.vue?vue&type=template&id=a4b46c7e&scoped=true", function () {
      api.rerender('a4b46c7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/OutboundCallingBot/components/Card.vue"
export default component.exports